<table>
    <thead>
        <tr>
            <th class="subtable string">{{'mantenimientoConfecciones.cajas.table.confeccion' | translate}}</th>
            <th class="subtable string">{{'mantenimientoConfecciones.cajas.table.denominacion' | translate}}</th>
            <th class="subtable number">{{'mantenimientoConfecciones.cajas.table.peso' | translate}}</th>
            <th class="subtable number">{{'mantenimientoConfecciones.cajas.table.numEnvasesCaja' | translate}}</th>
            <th class="subtable action"></th>
        </tr>
    </thead>
    <tbody *ngFor="let confeccionPallet of confeccionesPallet; let i = index">
        <tr>
            <td class="string">{{confeccionPallet.desConfeccion}}</td>
            <td class="string">{{confeccionPallet.desDenominacion}}</td>
            <td class="number">{{confeccionPallet.sumKilos | number : '1.2-2': defaultLanguage}}</td>
            <td class="number">{{confeccionPallet.numCajas}}</td>
            <td class="action">
                <i class="fas fa-stream" app-click-stop-propagation (click)="openTabs(i)"
                    title="{{dropdownSection === i ? ('global.minimizarDetalle' | translate) : ('global.mostrarDetalle' | translate)}}"></i>
            </td>
        </tr>
        <tr *ngIf="dropdownSection === i">
            <td colspan="5">
                <section class="tabs">
                    <ul>
                        <li [ngClass]="{'active': pestanaActiva === 1}" (click)="showEnvases()">{{'mantenimientoConfecciones.tabs.envases.titulo' | translate}}</li>
                    </ul>
                    <content>
                        <app-envases-confeccion *ngIf="pestanaActiva === 1" [cajasConfeccion]="confeccionPallet.lsDesgloseConfCaja"></app-envases-confeccion>
                    </content>
                </section>
            </td>
        </tr>
    </tbody>
    <tfoot *ngIf="!confeccionesPallet || (confeccionesPallet && confeccionesPallet.length < 1)">
        <tr>
            <td colspan="9">
                {{'global.noContent' | translate}}
            </td>
        </tr>
    </tfoot>
</table>